import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { VerticalListing, Link, MaskedLink } from '@hz-design-system/web-ui';
import { seoUrlPart } from '@ecg-marktplaats/aurora-js-formatters';

import formatPrice from '../../../utils/formatPrice';
import { getLargeImageUrl } from '../../../utils/getImageUrls';
import { getGATrackingAttrForSSR } from '../../../utils/gaTracking';

import { TSellerOtherItem } from 'types/TSellerOtherItem';

type TSellerItemProps = {
  item: TSellerOtherItem;
  className?: string;
};

const formatGATrackingAttr = (item: TSellerOtherItem): object =>
  getGATrackingAttrForSSR(
    'seller_own_ads',
    `${item.category.parentId}_${seoUrlPart(item.category.parentName)}/${item.category.id}_${seoUrlPart(
      item.category.fullName,
    )}`,
  );

const SellerItem = ({ item, className }: TSellerItemProps) => {
  const { t } = useI18nContext();

  const LinkComponent = item.thinContent ? MaskedLink : Link;

  return (
    <LinkComponent kind="block" href={item.url} className={className} {...formatGATrackingAttr(item)}>
      <VerticalListing
        className={className}
        title={item.title}
        alt={`${item.title} ${t('sellerOtherItems.imageAltText')}`}
        price={formatPrice(item.price, t)}
        imageSrc={getLargeImageUrl(item.imageUrls?.[0], item.imageSizes)}
        imageLoading="lazy"
        decoding="async"
      />
    </LinkComponent>
  );
};

export default SellerItem;
